'use strict'

module.exports = require('./match')(/^[a-zA-Z0-9]+$/)


/*****************
 ** WEBPACK FOOTER
 ** ./~/ustring/src/is/alphanum.js
 ** module id = 833
 ** module chunks = 0
 **/